// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"68":"press","353":"contact","621":"supporter","774":"imprint","983":"products"}[chunkId] + "." + {"68":"e85aee19","353":"b6c28d72","621":"29eea58d","774":"62453eba","983":"8872ffe5"}[chunkId] + ".js";
};